<template>
  <div class="grid">
    {{matchedGuest.name}}
    <el-input
      type="textarea"
      :rows="8"
      placeholder="messaggio"
      v-model="message">
    </el-input>
    <div class="grid btnlist" key="btnlist">
      <button class="btn" @click="$emit('close')"><unicon name="times" height="16" width="16" fill="#333"  /></button>
      <button class="btn green" @click="sendMessage">Manda messaggio</button>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
// import helper from '../Mixins/helper'
export default {
  name: 'Pushmessage',
  // mixins: [helper],
  props: {
    matchedGuest: Object
  },
  data () {
	return {
		changes: false,
    message: ''
	}
  },
  methods: {
  sendMessage () {
    this.$store.dispatch('guests/sendPushMessage', {matchedGuest: this.matchedGuest, message: this.message}).then(() => {
      this.$emit('close')
    })
  },
	show (section) {
		console.log(section)
		this.$emit('open', section)
	},
	save () {
		console.log('save')
		// this.$store.dispatch('hotels/updateHotel', this.hotel)
	}
  },
  filters: {

  },
  watch: {

  },
  computed: {

  },
  beforeMount () {

  },
  beforeDestroy () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
